import { useContext, useState, useEffect } from 'react';
import { DataContext } from '../../data/DataContext';
import { currency, plan } from '../../data/MochaData';
import { DropDown, TableBien, ModalControl } from '../controls';
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import { propLoading } from '../../data/Help';


const Step3 = () => {

    const { IH_CR, setIH_CR , changeHandler} = useContext(DataContext);
    const [lstPaymentFrequency, setLstPaymentFrequency] = useState([]);
    const [propModal, setPropModal] = useState(propLoading);


    useEffect(() => {
        GetInformation();
    }, [IH_CR.currency]);

    const onChangeCbo = (property: string, value: string) => {
        setIH_CR({ ...IH_CR, [property]: value });
    }

    const GetInformation = () => {
        let idPlan = IH_CR.currency === 'U$' ? plan.dolar : (IH_CR.currency === '¢' ? plan.colon : '');
        if (idPlan !== '') {
            setPropModal({ ...propModal, active: true });
            Promise.all([
                http(endPoints.coverages(idPlan)).get(),
                http(endPoints.configPlan(5, idPlan)).get(),
                http(endPoints.fees(idPlan)).getWithParam(`plan=${idPlan}`)
            ]).then((result) => {
                setIH_CR({ ...IH_CR, lstCoverages: result[0], planConfig: result[1], idPlan: idPlan });
                setLstPaymentFrequency(result[2]);
            })
                .finally(() => {
                    setPropModal({ ...propModal, active: false });
                });
        }
    }

    return (
        <>
            <DropDown
                label='Moneda*'
                dataProvider={currency}
                valueSelect={IH_CR.currency}
                field='currency'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona un plan'
            />
            <DropDown
                label='Cuotas*'
                dataProvider={lstPaymentFrequency}
                valueSelect={IH_CR.paymentFrequency}
                field='paymentFrequency'
                onChangeSelect={onChangeCbo}
            />
            <TableBien label='Bienes asegurados*'
                typeBien2='typeBien_Id2'
                typeBien3='typeBien_Id3'
                valueTypeBien2={IH_CR.typeBien_Id2.toString()}
                valueTypeBien3={IH_CR.typeBien_Id3.toString()}
                onChange={changeHandler}
            />
            <ModalControl
                active={propModal.active}
                txtMsg={propModal.txtMsg}
            />
        </>
    );
}

export { Step3 };